import { render, staticRenderFns } from "./FadeFooterButton.vue?vue&type=template&id=95b71f1c&scoped=true"
import script from "./FadeFooterButton.vue?vue&type=script&lang=ts"
export * from "./FadeFooterButton.vue?vue&type=script&lang=ts"
import style0 from "./FadeFooterButton.vue?vue&type=style&index=0&id=95b71f1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b71f1c",
  null
  
)

export default component.exports